<div mat-dialog-content>
  <lemon-dialog-header>
    Valitse kieli /<!-- Ändra språk /-->
    Choose language
  </lemon-dialog-header>
  <mat-radio-group [formField]="kieli" style="display: inline-flex; flex-direction: column" cdkFocusRegionstart>
    <mat-radio-button value="fi">Suomi</mat-radio-button>
    <!-- <mat-radio-button value="sv">Svenska</mat-radio-button> -->
    <mat-radio-button value="en">English</mat-radio-button>
  </mat-radio-group>
</div>
<div mat-dialog-actions>
  <app-primary-button actionId="Valitse kieli: Peruuta" mat-dialog-close>{{ 'yleiset.peruuta' | translate | async }}</app-primary-button>
</div>
